import { render, staticRenderFns } from "./WizardContentMediaRemover.vue?vue&type=template&id=8006ae30&scoped=true&"
import script from "./WizardContentMediaRemover.vue?vue&type=script&lang=ts&"
export * from "./WizardContentMediaRemover.vue?vue&type=script&lang=ts&"
import style0 from "./WizardContentMediaRemover.vue?vue&type=style&index=0&id=8006ae30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8006ae30",
  null
  
)

export default component.exports